import React from 'react';
import { Col } from 'react-bootstrap';

export const ColCenter = (props) => {
    return (
        <Col className='d-flex align-items-center justify-content-center wrapper'>
            {props.children}
        </Col>
    );
}